import { isPlainObject } from "lodash-es";

export const parseJsonObject = <T extends Record<string, unknown>>(
  jsonString: string,
): T => {
  const parsed = JSON.parse(jsonString) as T;

  if (isPlainObject(parsed)) {
    return parsed;
  }

  throw new TypeError(`Parsed JSON is ${typeof parsed}, not an object`);
};

export const tryParseContentDispositionFilename = (
  headers: Headers,
  fallbackFilename: string,
): string => {
  const contentDisposition = headers.get("Content-Disposition");

  if (!contentDisposition) {
    return fallbackFilename;
  }

  const filenameStarRegex = /filename\*\s*=\s*(?:UTF-8''|utf-8'')?([^;]+)/;
  const filenameStarMatch = filenameStarRegex.exec(contentDisposition);

  if (filenameStarMatch?.[1]) {
    const encodedFilename = filenameStarMatch[1]
      .trim()
      .replaceAll(/^"|"$/g, "");

    try {
      return decodeURIComponent(encodedFilename);
    } catch {
      return encodedFilename;
    }
  }

  const filenameRegex = /filename\s*=\s*([^;]+)/;
  const filenameMatch = filenameRegex.exec(contentDisposition);

  if (filenameMatch?.[1]) {
    return filenameMatch[1].trim().replaceAll(/^"|"$/g, "");
  }

  return fallbackFilename;
};
